module.exports = __webpack_public_path__ + "img/rm5.ca97ed24.jpg";